<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ rateLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field
              label="Name"
              v-model="r.name"
              @input="$v.r.name.$touch()"
              @blur="$v.r.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              label="Rate Code"
              v-model="r.code"
              @input="$v.r.code.$touch()"
              @blur="$v.r.code.$touch()"
              :error-messages="codeErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm3>
            <v-text-field
              label="Min Stay"
              v-model.number="r.minStay"
              type="number"
              min="0"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              label="Max Stay"
              v-model.number="r.maxStay"
              type="number"
              min="0"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              label="Min Pax"
              v-model.number="r.minPax"
              type="number"
              min="0"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              label="Max Pax"
              v-model.number="r.maxPax"
              type="number"
              min="0"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm4>
            <v-checkbox
              label="Inc Pax"
              v-model="r.includePax"
              primary
              hide-details
              :disabled="r.includeQuantity"
            ></v-checkbox>
          </v-flex>
          <v-flex sm4>
            <v-checkbox
              label="Inc Days"
              v-model="r.includeDays"
              primary
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex sm4>
            <v-checkbox
              label="Inc Quantity"
              v-model="r.includeQuantity"
              primary
              hide-details
              :disabled="r.includePax"
            ></v-checkbox>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col>
            <v-switch label="Not in Use" v-model="r.notInUse" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  RATE_TYPE_UPDATE_MUTATION,
  RATE_TYPE_CREATE_MUTATION,
} from "../../../../constants/graphql";
import TaxesListSelect from "../../shared/TaxesListSelect";
import { required } from "vuelidate/lib/validators";

export default {
  name: "RateEditor",

  components: {
    TaxesListSelect,
  },

  props: {
    rate: {
      type: Object,
      default: () => ({}),
    },

    doSaveRate: {
      type: Boolean,
      default: false,
    },

    rateEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      r: { ...this.rate },
      debug: false,
    };
  },

  methods: {
    saveRate() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? RATE_TYPE_UPDATE_MUTATION
            : RATE_TYPE_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.r,
            },
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    rateLabel() {
      return this.rate.id != null ? this.rate.name : "New Rate Type";
    },
    context() {
      return this.rate.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.r.name.$dirty) {
        return errors;
      }
      if (!this.$v.r.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    codeErrors() {
      let errors = [];
      if (!this.$v.r.code.$dirty) {
        return errors;
      }
      if (!this.$v.r.code.required) {
        errors.push("Rate code is required.");
      }
      return errors;
    },
  },

  watch: {
    rate(data) {
      let rate = { ...data };
      delete rate.__typename;
      this.r = rate;
    },
    rateEditorDialog(value) {
      if (!value) {
        this.r = {};
        this.$v.$reset();
      }
    },
    doSaveRate(value) {
      if (value) {
        this.saveRate();
      }
    },
  },
  validations: {
    r: {
      name: { required },
      code: { required },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/department-types/RateEditor.vue